import { getProcedureResult } from 'iguazu-rpc';

import {
  BSA_BASE_ROUTE,
  READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
  BCA_ROUTES,
  BSA_ROUTES,
} from '../constants';
import { hasBcaProduct, hasBsaProduct } from './productUtil';
import redirect from './redirect';

const isSavingsUrl = (pathname) => pathname.includes(BSA_BASE_ROUTE);

const redirectToProductHome = (store) => (nextState, replace) => {
  const state = store.getState();
  const productsResult = getProcedureResult({
    procedureName: READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
    args: {
      timeout: 6e3,
    },
  })(state);

  const hasBca = hasBcaProduct(productsResult);
  const hasBsa = hasBsaProduct(productsResult);
  const isOnSavingsUrl = isSavingsUrl(nextState.location.pathname);

  if (hasBca && hasBsa) {
    redirect(isOnSavingsUrl ? BSA_ROUTES.HOME : BCA_ROUTES.HOME, replace);
    return;
  }

  if (hasBca) {
    redirect(BCA_ROUTES.HOME, replace);
    return;
  }

  if (hasBsa) {
    redirect(BSA_ROUTES.HOME, replace);
    return;
  }

  redirect(BCA_ROUTES.HOME, replace);
};

export default redirectToProductHome;
